import {
  getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount,
  getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import { nullifyNotFound } from '@fukuri-admins/utils/common';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
  /** 口座情報を取得する利用者ID */
  userId: number;
};

type ReturnType = {
  /** 口座情報レスポンス。null = 未連携（404） */
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200 | null;
};

type IUseGetPartnerAdminsUserBankAccount = (args: Args) => ReturnType;

/**
 * パートナー管理者向け利用者口座情報単一取得フック
 *
 * 404（口座未連携）の場合は fetcher がエラーを catch して null を返す。
 */
export const useGetPartnerAdminsUserBankAccount: IUseGetPartnerAdminsUserBankAccount = ({
  threeLetterCode,
  userId,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountKey(threeLetterCode, userId),
    () =>
      getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount(threeLetterCode, userId).catch(
        nullifyNotFound
      ),
    { suspense: true, shouldRetryOnError: false }
  );

  return { data };
};
